(() => {
  if (window.HiskinHomepageMotion) {
    window.HiskinHomepageMotion.initAll();
    return;
  }

  const controllers = new WeakMap();
  const clamp = (value) => Math.max(0, Math.min(1, value));

  function readHeaderMetrics(root) {
    const header = document.querySelector(
      "sticky-header, .shopify-section-group-header-group, #shopify-section-header, .header-wrapper"
    );
    if (!header || root.contains(header)) {
      return { height: 0, sticky: false };
    }

    const rect = header.getBoundingClientRect();
    const style = window.getComputedStyle(header);
    return {
      height: Math.min(150, Math.max(0, Math.round(rect.height))),
      sticky:
        style.position === "sticky" ||
        style.position === "fixed" ||
        Boolean(header.querySelector("sticky-header")),
    };
  }

  function progressThrough(element) {
    const rect = element.getBoundingClientRect();
    const distance = Math.max(1, element.offsetHeight - window.innerHeight);
    return clamp(-rect.top / distance);
  }

  function bind(root) {
    if (!root || controllers.has(root)) return;

    const controller = new AbortController();
    const { signal } = controller;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const motionEnabled = root.dataset.motion !== "false" && !reduceMotion;
    let ticking = false;

    const draw = () => {
      if (root.matches("[data-hsk-hero]")) {
        const metrics = readHeaderMetrics(root);
        root.style.setProperty("--hsk-header-height", `${metrics.height}px`);
        root.style.setProperty("--hsk-sticky-top", metrics.sticky ? `${metrics.height}px` : "0px");
        root.style.setProperty("--hsk-hero-progress", progressThrough(root));
      }

      if (root.matches("[data-hsk-history]")) {
        root.style.setProperty("--hsk-history-progress", progressThrough(root));
      }

      if (root.matches("[data-hsk-research]")) {
        const raw = progressThrough(root);
        const reveal = clamp((raw - 0.2) / 0.6);
        root.style.setProperty("--hsk-research-progress", reveal);
      }

      ticking = false;
    };

    const requestDraw = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(draw);
    };

    if (!motionEnabled) root.classList.add("hsk-motion-off");
    if (motionEnabled) {
      window.addEventListener("scroll", requestDraw, { passive: true, signal });
    }
    window.addEventListener("resize", requestDraw, { signal });
    draw();

    controllers.set(root, controller);
  }

  function unbind(root) {
    const controller = controllers.get(root);
    if (controller) controller.abort();
    controllers.delete(root);
  }

  function initAll(scope = document) {
    scope
      .querySelectorAll("[data-hsk-hero], [data-hsk-history], [data-hsk-research]")
      .forEach(bind);
  }

  window.HiskinHomepageMotion = { initAll, bind, unbind };

  document.addEventListener("DOMContentLoaded", () => initAll());
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    const root = event.target.querySelector(
      "[data-hsk-hero], [data-hsk-history], [data-hsk-research]"
    );
    if (root) unbind(root);
  });

  initAll();
})();
